export default {
  base: CONFIG.API_BASE,
  baseV2: CONFIG.API_BASE_V2,
  basePayrollPortal: CONFIG.PAYROLL_PORTAL_API_ROOT,
  baseBiller: CONFIG.BILLER_API_ROOT,
  getBaseCMOS: () => {
    return CONFIG.COGNITO.Gateways.cmosUrl;
  },
  getBase: () => {
    return CONFIG.COGNITO.Gateways.apiV1Url;
  },
  getBaseV2: () => {
    return CONFIG.COGNITO.Gateways.apiV2Url;
  }, 
}